import React from 'react';
import Slider from 'react-slick';
import img1 from '../../media/coristo.png';
import img2 from '../../media/b&b.png';
import img3 from '../../media/basiaCarrousel.png';
import img4 from '../../media/promyk.png';
import img5 from '../../media/ponchoCarrousel.png';
import img6 from '../../media/p&b.png';
import { Grid, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';
import './Carrousel.css';

const Carrousel = () => {
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  const imgs = [
    { src: img1, name: 'Coristo' },
    { src: img2, name: 'Bajka & Balou' },
    { src: img3, name: 'Barbara Jimenez' },
    { src: img4, name: 'Promyk' },
    { src: img5, name: 'Alfonso Jimenez' },
    { src: img6, name: 'Pasja & Frika' },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5500,
    fade: true,
    arrows: false,
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    pauseOnHover: true,
  };

  return (
    <Grid
      className={`carousel-root ${darkMode ? 'dark' : 'light'}`}
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        bgcolor: darkMode ? '#121212' : '#FFFFFF',
        pt: { xs: 2, md: 4 },
        pb: { xs: 2, md: 4 },
        px: { xs: 2, md: 4 },
      }}
    >
      <Grid item xs={12} sx={{ width: '100%', maxWidth: '1200px', mx: 'auto' }}>
        <Slider {...settings}>
          {imgs.map((img, index) => (
            <div key={index}>
              <Box
                sx={{
                  bgcolor: darkMode ? '#1a1a1f' : '#FFFFFF',
                }}
              >
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={7}>
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        pt: { xs: '58%', md: '56%' },
                        bgcolor: darkMode ? '#1a1a1f' : '#FFF',
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          top: { xs: 10, md: 14 },
                          left: { xs: 10, md: 14 },
                          width: { xs: 28, md: 36 },
                          height: { xs: 28, md: 36 },
                          borderTop: `1px solid ${darkMode ? '#555555' : '#CCCCCC'}`,
                          borderLeft: `1px solid ${darkMode ? '#555555' : '#CCCCCC'}`,
                          borderRadius: '2px',
                          zIndex: 2,
                        },
                        '&::after': {
                          content: '""',
                          position: 'absolute',
                          right: { xs: 10, md: 14 },
                          bottom: { xs: 10, md: 14 },
                          width: { xs: 28, md: 36 },
                          height: { xs: 28, md: 36 },
                          borderRight: `1px solid ${darkMode ? '#555555' : '#CCCCCC'}`,
                          borderBottom: `1px solid ${darkMode ? '#555555' : '#CCCCCC'}`,
                          borderRadius: '2px',
                          zIndex: 2,
                        },
                      }}
                    >
                      <Box
                        aria-hidden
                        sx={{
                          position: 'absolute',
                          top: { xs: 14, md: 20 },
                          right: { xs: 14, md: 20 },
                          width: { xs: 26, md: 34 },
                          height: { xs: 26, md: 34 },
                          borderRadius: '50%',
                          border: `1px solid ${theme.palette.primary.main}`,
                          opacity: 0.25,
                          zIndex: 2,
                        }}
                      />
                      <Box
                        component="img"
                        src={img.src}
                        alt={img.name}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          objectPosition: 'center',
                          p: { xs: 1, md: 1.5 },
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <Box
                      sx={{
                        p: { xs: 2.5, md: 4 },
                        borderLeft: { md: `1px solid ${darkMode ? '#333333' : '#EEEEEE'}` },
                        borderTop: { xs: `1px solid ${darkMode ? '#333333' : '#EEEEEE'}`, md: 'none' },
                        bgcolor: darkMode ? '#1a1a1f' : '#FFFFFF',
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={400}
                        sx={{
                          color: darkMode ? '#FFFFFF' : '#000000',
                          textAlign: { xs: 'center', md: 'left' },
                          letterSpacing: '-0.3px',
                        }}
                      >
                        {img.name}
                      </Typography>
                      <Box
                        sx={{
                          mt: 1.5,
                          width: '48px',
                          height: '2px',
                          bgcolor: theme.palette.primary.main,
                          mx: { xs: 'auto', md: 0 },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </div>
          ))}
        </Slider>
      </Grid>
    </Grid>
  );
};

export default Carrousel;
